import React, { Children } from "react";
import styled from "styled-components";
import { device } from "../../WSUtils/constants/mediaQueries";

export interface CvpPanelProps extends React.HTMLProps<HTMLAnchorElement> {
  anotherProp?: boolean;
}

const _CvpPanelLink: React.FC<CvpPanelProps> = ({ anotherProp, ...rest }) => {
  return <a {...rest} />;
};

export const CvpPanelLink = styled(_CvpPanelLink)`
  border: 2px solid var(--primary-200);
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  column-gap: 0.7rem;
  padding: 1.2rem 1rem;
`;

export default CvpPanelLink;
